import { TabsReducer } from '../../../../common/tabs/tabs.reducer';
import {IDS} from "../settings-action-id.constants";

export const evidenceTabs = {
    [IDS.app_accreditation_scheme_settings_evidence]: Object.assign(TabsReducer(), {
        tabs: [
            {
                state: IDS.app_accreditation_scheme_settings_evidence_list,
                title: 'ACCREDITATION.SETTINGS.HOF_REQUIREMENT_EVIDENCE.LIST.TAB',
                visible: true,
                disabled: false,
                loading: false,
            },
            {
                state: IDS.app_accreditation_scheme_settings_evidence_details,
                title: 'ACCREDITATION.SETTINGS.HOF_REQUIREMENT_EVIDENCE.DETAILS.TAB',
                visible: false,
                disabled: false,
                loading: false,
            },
            {
                state: IDS.app_accreditation_scheme_settings_evidence_applicable_sites,
                title: 'ACCREDITATION.SETTINGS.HOF_REQUIREMENT_EVIDENCE.APPLICABLE_SITES.TAB',
                visible: false,
                disabled: true,
                loading: false,
                buttons: {
                    execute: {label: 'Save'}
                }
            },
            {
                state: IDS.app_accreditation_scheme_settings_evidence_add,
                title: 'ACCREDITATION.SETTINGS.HOF_REQUIREMENT_EVIDENCE.ADD.TAB',
                visible: false,
                disabled: false,
                loading: false,
            },
            {
                state: IDS.app_accreditation_scheme_settings_evidence_imports,
                title: 'ACCREDITATION.SETTINGS.HOF_REQUIREMENT_EVIDENCE.IMPORTS.TAB',
                visible: false,
                disabled: false,
                loading: false,
            },
        ],
    }),
};
